import { ChevronLeft, ChevronRight } from 'lucide-react';

export const  QuickTourTooltip = ({
		backProps,
		closeProps,
		continuous,
		index,
		isLastStep,
		primaryProps,
		skipProps,
		step,
		tooltipProps,
	}) => {
		const isFirst = index === 0;
		const backActive = !isFirst; // highlight back on step > 0
		const nextActive = isFirst && !isLastStep; // highlight next on first step

		const btnBase = "inline-flex h-8 w-8 items-center justify-center rounded";
		const activeBtn = " bg-[#F8F2FC]";
		const inactiveBtn = " bg-[#F8F2FC]/40";
		const activeIcon = " text-[#B67FE2]";
		const inactiveIcon = " text-[#B67FE2]/40";

		return (
			<div
				{...tooltipProps}
				className="rounded-md border border-[#180A63] bg-white p-4 text-left shadow-lg max-w-[320px]"
			>
				<div className="mb-2">{step?.content}</div>
				<div className="mt-3 flex items-center justify-between">
				<button {...skipProps} type="button" className="text-sm font-semibold text-dark-blue">SKIP</button>
					<div className="flex items-center gap-2">
						<button
							{...(isFirst ? { onClick: (e) => { e.preventDefault(); e.stopPropagation(); } } : backProps)}
							type="button"
							className={btnBase + (backActive ? activeBtn : inactiveBtn)}
							disabled={isFirst}
							aria-label="Previous"
						>
							<ChevronLeft size={18} className={(backActive ? activeIcon : inactiveIcon).trim()} />
						</button>
						{!isLastStep && (
							<button
								{...primaryProps}
								type="button"
								className={btnBase + (nextActive ? activeBtn : inactiveBtn)}
								aria-label="Next"
							>
								<ChevronRight size={18} className={(nextActive ? activeIcon : inactiveIcon).trim()} />
							</button>
						)}
						{isLastStep && (
							<button onClick={primaryProps?.onClick} type="button" className="ml-1 h-8 px-3 rounded bg-dark-blue text-white text-xs hover:opacity-90">End</button>
						)}
					</div>
				</div>
			</div>
		);
	};